import './styles.scss';
import React, {useRef} from 'react';
import DateUtils from '../../../../services/DateUtils';
import { ResponsiveService } from '../../services/ResponsiveService';
import { __, STR_KEY } from '../../../../services/Translate';
import HtmlWrapper from '../../../../components/HtmlWrapper';

import {
	GeckoIcon
} from '@geckolabs/gecko-react-ui';

import Hosts from '../Hosts';

const DescriptionResponsiveMenu = () => {
	
	ResponsiveService.chat.ref.button      = useRef();
	ResponsiveService.reactions.ref.button = useRef();

	const btns = [{
		className: 'icon-btn responsive-btn-chat',
		'aria-label': 'Open Chat',
		onClick: () => ResponsiveService.chat.toggle(),
		icon: 'comments',
		ref: ResponsiveService.chat.ref.button
	}, {
		className: 'icon-btn responsive-btn-reactions',
		'aria-label': 'Open Reactions',
		onClick: () => ResponsiveService.reactions.toggle(),
		icon: 'thumbs-up',
		ref: ResponsiveService.reactions.ref.button
	}];
	return (
		<div className="event-description-responsive-menu">
			{btns.map((btn, i) => (
				<button key={i} type="button" {...btn}>
					<GeckoIcon icon={btn.icon} />
				</button>
			))}
		</div>
	);
};

const Description = ({event, hosts}) => {
    return (            
        <div className="description-container col gecko-ui-card card">
        	<div className="event-title-container">
				<h1 className="event-title branded-text">{event.title}</h1>
				<DescriptionResponsiveMenu />
			</div>
			<div className="event-time-container">
				<p className="event-date"><GeckoIcon icon="fa-clock" /> {DateUtils.renderStartDateTimeEndDateTime(event.start_datetime, event.end_datetime, '-')} ({event.timezone})</p>
			</div>
			<Hosts hosts={hosts} />
			<WebinarDescription description={event.description} />
        </div>
    );
}

export const WebinarDescription = ({ description }) => {
	if (description) {
		return (
			<>
				<p className="event-description-heading branded-text">{__(STR_KEY.VIDEO_DESCRIPTION_TITLE_ABOUT)}</p>
				<HtmlWrapper className="event-description" html={description} />
			</>
		);
	} return null;
}

export default Description;